module.exports = __webpack_public_path__ + "img/yindao.9fc4c442.png";